// extracted by mini-css-extract-plugin
export default {"wrapper":"Step1Deposit-module__wrapper","fade-in":"Step1Deposit-module__fade-in","dialogue":"Step1Deposit-module__dialogue"};